import(/* webpackMode: "eager", webpackExports: ["BlogPostClient"] */ "/home/runner/work/udata-site/udata-site/app/blog/[slug]/BlogPostClient.tsx");
